import AbstractEntryCommand from "./AbstractEntryCommand.js";

/**
 * `multipleUploadCommand` is used to upload multiple files at once.
 */
export default class MultipleUploadCommand extends AbstractEntryCommand {
	constructor() {
		super(...arguments);

		this._files = [];
	}

	getFiles() {
		return this._files;
	}

	setFiles(newFiles) {
		this._files = newFiles;
	}

	getFileUploadingCallback() {
		return this._fileUploadingCallback;
	}

	accept(aVisitor) {
		return aVisitor.visitMultipleUploadCommand(this);
	}

	requireRefresh() {
		return true;
	}

	uploadPath() {
		return this._documentService.uploadPath();
	}

	_performOnService(callback) {
		this._documentService.executeMultipleUploadCommand(this, callback);
	}

	_execute() {}

	// Never render the command in the right-hand menu, as it is only ever used for
	// drag and drop upload support.
	static isApplicable() {
		return false;
	}
}
